import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import ReactNodeView from '@atlaskit/editor-common/react-node-view';
import { DATASOURCE_INNER_CONTAINER_CLASSNAME, SmartCardSharedCssClassName } from '@atlaskit/editor-common/styles';
import { UnsupportedInline } from '@atlaskit/editor-common/ui';
import { calcBreakoutWidth } from '@atlaskit/editor-common/utils';
import { DatasourceTableView } from '@atlaskit/link-datasource';
import { DatasourceErrorBoundary } from '../datasourceErrorBoundary';
import { getLinkNodeType } from '../pm-plugins/doc';
var getPosSafely = function getPosSafely(pos) {
  if (!pos || typeof pos === 'boolean') {
    return;
  }
  try {
    return pos();
  } catch (e) {
    // Can blow up in rare cases, when node has been removed.
  }
};
// eslint-disable-next-line @repo/internal/react/no-class-components
export var DatasourceComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DatasourceComponent, _React$PureComponent);
  var _super = _createSuper(DatasourceComponent);
  function DatasourceComponent(props) {
    var _this;
    _classCallCheck(this, DatasourceComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getDatasource", function () {
      return _this.props.node.attrs.datasource;
    });
    _defineProperty(_assertThisInitialized(_this), "getTableView", function (datasource) {
      var views = (datasource || _this.getDatasource()).views;
      return views.find(function (view) {
        return view.type === 'table';
      }) || undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "handleColumnChange", function (columnKeys) {
      var _this$props$view = _this.props.view,
        state = _this$props$view.state,
        dispatch = _this$props$view.dispatch;
      var pos = getPosSafely(_this.props.getPos);
      if (pos === undefined) {
        return;
      }
      var attrs = _this.props.node.attrs;
      var views = [{
        type: 'table',
        properties: {
          columns: columnKeys.map(function (key) {
            return {
              key: key
            };
          })
        }
      }];
      var tr = state.tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, attrs), {}, {
        datasource: _objectSpread(_objectSpread({}, attrs.datasource), {}, {
          views: views
        })
      }));
      tr.setMeta('scrollIntoView', false);
      dispatch(tr);
    });
    _defineProperty(_assertThisInitialized(_this), "onError", function (_ref) {
      var err = _ref.err;
      if (err) {
        throw err;
      }
    });
    return _this;
  }
  _createClass(DatasourceComponent, [{
    key: "render",
    value: function render() {
      var cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
      var datasource = this.getDatasource();
      var tableView = this.getTableView();
      if (tableView) {
        var _tableView$properties;
        var visibleColumnKeys = (_tableView$properties = tableView.properties) === null || _tableView$properties === void 0 ? void 0 : _tableView$properties.columns.map(function (_ref2) {
          var key = _ref2.key;
          return key;
        });

        // [WS-2307]: we only render card wrapped into a Provider when the value is ready
        if (cardContext && cardContext.value) {
          return jsx(cardContext.Provider, {
            value: cardContext.value
          }, jsx(DatasourceTableView, {
            datasourceId: datasource.id,
            parameters: datasource.parameters,
            visibleColumnKeys: visibleColumnKeys,
            onVisibleColumnKeysChange: this.handleColumnChange
          }));
        }
      }
      return null;
    }
  }]);
  return DatasourceComponent;
}(React.PureComponent);
_defineProperty(DatasourceComponent, "contextTypes", {
  contextAdapter: PropTypes.object
});
export var Datasource = /*#__PURE__*/function (_ReactNodeView) {
  _inherits(Datasource, _ReactNodeView);
  var _super2 = _createSuper(Datasource);
  function Datasource(props) {
    var _props$pluginInjectio, _props$pluginInjectio2, _sharedState$currentS;
    var _this2;
    _classCallCheck(this, Datasource);
    _this2 = _super2.call(this, props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props, undefined, true, undefined, props.hasIntlContext);
    // this is necessary so that the datasource toolbar won't be rendered on error
    _defineProperty(_assertThisInitialized(_this2), "updateNodeRemoveAttrs", function () {
      var url = _this2.node.attrs.url;
      var _this2$view = _this2.view,
        state = _this2$view.state,
        dispatch = _this2$view.dispatch;
      var pos = getPosSafely(_this2.getPos);
      if (pos === undefined) {
        return;
      }
      var nodeType = getLinkNodeType('inline', state.schema.nodes);
      var tr = state.tr.setNodeMarkup(pos, nodeType, {
        url: url
      });
      tr.setMeta('scrollIntoView', false);
      return dispatch(tr);
    });
    var sharedState = props === null || props === void 0 ? void 0 : (_props$pluginInjectio = props.pluginInjectionApi) === null || _props$pluginInjectio === void 0 ? void 0 : (_props$pluginInjectio2 = _props$pluginInjectio.width) === null || _props$pluginInjectio2 === void 0 ? void 0 : _props$pluginInjectio2.sharedState;
    _this2.tableWidth = sharedState === null || sharedState === void 0 ? void 0 : (_sharedState$currentS = sharedState.currentState()) === null || _sharedState$currentS === void 0 ? void 0 : _sharedState$currentS.width;
    sharedState === null || sharedState === void 0 ? void 0 : sharedState.onChange(function (_ref3) {
      var nextSharedState = _ref3.nextSharedState;
      if (nextSharedState !== null && nextSharedState !== void 0 && nextSharedState.width && _this2.tableWidth !== (nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.width)) {
        _this2.tableWidth = nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.width;
        _this2.update(_this2.node, []); // required to update the width when page is resized.
      }
    });
    return _this2;
  }
  _createClass(Datasource, [{
    key: "createDomRef",
    value: function createDomRef() {
      var domRef = document.createElement('div');
      domRef.classList.add(SmartCardSharedCssClassName.DATASOURCE_CONTAINER);
      return domRef;
    }
  }, {
    key: "render",
    value: function render() {
      var attrs = this.node.attrs;
      return jsx(DatasourceErrorBoundary, {
        handleError: this.updateNodeRemoveAttrs,
        unsupportedComponent: UnsupportedInline,
        view: this.view,
        url: attrs.url
      }, jsx("div", {
        className: DATASOURCE_INNER_CONTAINER_CLASSNAME,
        style: {
          minWidth: calcBreakoutWidth(attrs.layout, this.tableWidth)
        }
      }, jsx(DatasourceComponent, {
        node: this.node,
        view: this.view,
        getPos: this.getPos
      })));
    }
  }]);
  return Datasource;
}(ReactNodeView);